import DOMPurify from 'dompurify'

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Uses DOMPurify to remove potentially dangerous content.
 *
 * @param html - The HTML string to sanitize
 * @returns Sanitized HTML string safe for dangerouslySetInnerHTML
 */
export function sanitizeHtml(html: string | undefined | null): string {
  if (!html) {
    return ''
  }
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'br',
      'hr',
      'ul',
      'ol',
      'li',
      'a',
      'strong',
      'em',
      'b',
      'i',
      'u',
      's',
      'strike',
      'blockquote',
      'pre',
      'code',
      'table',
      'thead',
      'tbody',
      'tr',
      'th',
      'td',
      'div',
      'span',
      'img',
      'sub',
      'sup',
    ],
    ALLOWED_ATTR: [
      'href',
      'target',
      'rel',
      'src',
      'alt',
      'title',
      'width',
      'height',
      'class',
      'style',
      'colspan',
      'rowspan',
    ],
    // Ensure links open safely
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover'],
  })
}

/**
 * Create props for dangerouslySetInnerHTML with sanitized content.
 *
 * @param html - The HTML string to sanitize
 * @returns Object suitable for spreading into dangerouslySetInnerHTML
 */
export function createSanitizedHtml(html: string | undefined | null): {
  __html: string
} {
  return { __html: sanitizeHtml(html) }
}
